import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DateService, IQuestion, SharedConfig, SharedFormulaService } from '@takectrl-multiapp/svcs-share-config';
@Component({
  selector: 'input-datepicker',
  standalone: false,
  templateUrl: './input-datepicker.component.html',
  styleUrls: ['./input-datepicker.component.scss'],
})
export class InputDatepickerComponent implements OnInit {
  maxDate: any;
  minDate: any;
  @Input() question: IQuestion;
  @Input() showHeading: boolean;
  @Input() error: string;
  @Input() readOnly: boolean;
  @Output() answerQuestion: EventEmitter<IQuestion> = new EventEmitter();
  currentYear: number;
  constructor(public sharedConfig: SharedConfig, public sharedFormulaService: SharedFormulaService, public dateService: DateService) {}

  ngOnInit(): void {
    this.maxDate = this.question.underwriting_answers[0].max
      ? this.sharedFormulaService.formatDateyyymmdd(this.question.underwriting_answers[0].max * 1000)
      : null;
    this.minDate = this.question.underwriting_answers[0].min
      ? this.sharedFormulaService.formatDateyyymmdd(this.question.underwriting_answers[0].min * 1000)
      : null;
  }

  getMaxCoverStartDate(): number {
    const date = new Date();
    date.setMonth(date.getMonth() + 3);
    return date.getTime();
  }

  openCalendar() {
    SharedConfig.showCalendarPopup = true;
    SharedConfig.hideProgressBar = true;
    SharedConfig.showFullScreen = true;
  }

  answerValue(dateValue) {
    this.question.underwriting_answers[0].object_answer = dateValue.split('T')[0];
    this.answerQuestion.emit(this.question);
  }
}
